/**
 * Будує компактне прев'ю медіа повідомлення для блоку відповіді (як у Telegram).
 * Повертає null, якщо в повідомленні немає вкладень.
 */
export function buildReplyPreview(message) {
  if (!message) return null;

  const files = [];
  if (message.image) files.push(message.image);
  if (Array.isArray(message.media)) files.push(...message.media);

  if (files.length > 0) {
    const first = files[0] || {};
    return {
      kind: typeof first.type === 'string' && first.type.startsWith('video/') ? 'video' : 'image',
      path: String(first.path || '').replace(/^\/+/, ''),
      count: files.length
    };
  }

  if (message.audio) {
    return { kind: 'audio', path: '', count: 1 };
  }

  return null;
}
